import React, { useState, useEffect, useRef } from "react";
import { _getBaseUrl, _makeId, _isFirstRender } from "../utils/helper";
import { Checkbox } from "../forms";

const FilterDropDown = ({ placeholder, nodeType, isFilter, ...props }) => {
  const dropdownRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  // if (props.options) {
  //   props.options.sort((a, b) => {
  //     if (a.label === "De HER") return 1;
  //     if (b.label === "De HER") return -1;
  //     return 0;
  //   });
  // }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const dropdownExpandHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const onChangeHandler = (checked, value) => {
    props.onChange(props.filter, value, checked);
  };

  const title = `Alle ${placeholder}`;

  return (
    <fieldset
      className="filter-dropdown--wrapper relative border-none"
      ref={dropdownRef}
      aria-labelledby={`dropdown-header-${placeholder}`}
    >
      <legend
        id={`dropdown-header-${placeholder}`}
        className="text-cirBlack text-base pb-4 capitalize"
      >
        {placeholder}
      </legend>

      <div
        className={`filter-list border border-black border-opacity-20 rounded-md py-4 px-4 md:px-8 flex items-center justify-between cursor-pointer ${props.toggleClass ? props.toggleClass : ""
          }`}
        aria-expanded={isExpanded}
        onClick={() => dropdownExpandHandler()}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            dropdownExpandHandler();
          }
        }}
        tabIndex={0}
        role="button"
        aria-controls="filter-options"
      >
        <span className="text-base">{title}</span>
        <img
          src={`${_getBaseUrl("src/assets/icons/arrow-down.svg", true)}`}
          alt=""
          className={`filter brightness-0 ${isExpanded ? "rotate-180" : ""}`}
          aria-hidden="true"
        />
      </div>

      {isExpanded && (
        <div
          id="filter-options"
          className={`filter-dropdown--tray bg-white border border-black border-opacity-20 rounded-md mt-2
          ${!isFilter && nodeType === "all" ? "md:block" : "md:absolute"}
          md:z-10 md:top-full md:left-0 p-5
          ${props.trayClass ? props.trayClass : "w-full"}`}
          role="group"
          aria-labelledby={`dropdown-header-${placeholder}`}
        >
          <div
            className={`pr-4 grid grid-cols-1 gap-2 ${props.trayBodyClass ? props.trayBodyClass : ""
              }`}
          >
            {props.options !== undefined &&
              props.options.length > 0 &&
              props.options.map((item) => {
                return (
                  <div key={item.value}>
                    <Checkbox
                      label={item.label}
                      value={item.value}
                      checked={
                        props.value.indexOf(item.value) >= 0 ? true : false
                      }
                      onChange={onChangeHandler}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </fieldset>
  );
};

export default FilterDropDown;
